import {useState} from 'react';
import {Ticket} from '../types';
import {persistReply, replyForSharing, UpdateTicket} from '../services/replies';
import {errorMessage} from '../errors';
import {toast} from '../components/ui/sonner';

interface Options {ticket: Ticket; draft: string; dirty: boolean; setDraft: (draft: string) => void; update: UpdateTicket}
export function useReplySubmission({ticket, draft, dirty, setDraft, update}: Options) {
  const [saving, setSaving] = useState(false);
  async function save(approve = false): Promise<Ticket | null> {
    setSaving(true);
    try {
      const result = await persistReply(ticket.id, draft, approve, update);
      setDraft(result.draft); toast.success(approve ? 'Reply approved — ready to copy' : 'Draft saved'); return result;
    } catch (error: unknown) { toast.error(errorMessage(error)); return null; }
    finally { setSaving(false); }
  }
  async function copy(): Promise<void> {
    try {
      const saved = await replyForSharing(ticket, dirty, save);
      if (!saved) return;
      await navigator.clipboard.writeText(saved.draft); toast.success('Reply copied to clipboard');
    } catch { toast.error('Clipboard access was blocked. Select and copy the reply manually.'); }
  }
  return {saving, save, copy};
}